import Link from 'next/link';
import styles from './page-title-bar.module.scss';
import { useTranslation } from 'react-i18next';

export interface PageTitleBarProps {
  readonly title: string;
  readonly backLink?: string;
}

const PageTitleBar: React.FC<PageTitleBarProps> = ({ title, backLink }) => {
  const { t } = useTranslation('common');

  return (
    <div className={styles.container}>
      {backLink ? (
        <Link className={styles.backLink} href={backLink}>
          {t('back')}
        </Link>
      ) : null}
      <h1 className={styles.title}>{title}</h1>
    </div>
  );
};

export default PageTitleBar;
